import React, {
    useState, Fragment,
    useEffect
} from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form"; //, Controller
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { mapStateToProps } from "../../../redux/reducers";
import { connect } from "react-redux";
import { UPDATE_VENDOR } from "../../../redux/actionTypes/vendordetails";
import { PUT_USER, SET_USER, clearRegistrationStatus } from "../../../redux/actionTypes/registration";
import "../../../styles/registration.scss";
import { convertUTCDateToLocalDate, isNumber, maskMobile ,isAlphanumeric} from "../../../utils/globalMethods";
import { getVendorInfoList } from "../../../redux/actionTypes/vendordetails";
import CommonLoading from "../../common/components/commonLoading";
import { popUpAlert } from "../../../utils/globalMethods";

const CsaVendorDetailsTab = (props) => {
    let initial = {
        vendorName: "",
        fnsNum: [{ id: 0, name: "" }], 
        firstName: "",
        lastName: "",
        primaryMobile: "",
        primaryEmail: "",
        createdBy: "",
        createTs: "",
        lastUpdtTs: "",
        adminLastUpdtTs: "",
        lastUpdtUidNam: "",
        lastUpdtUid: "",
        additionalContactInfo: "",
        communicationEmail:[{ id: 0, email: "" }]
    };
    
    const userData = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));
    const [mode, setMode] = useState(props.add_CSA ? "edit":"view");
    const [mobile, setMobile] = useState("");
    const [update, setUpdate] = useState(false);
    const [formValue, setFormValue] = useState(initial);
    // eslint-disable-next-line no-unused-vars
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const {
        register,
        formState: { errors },
        handleSubmit,
        control,
        watch,
        reset
    } = useForm({
        defaultValues: formValue
    });

    useEffect(() => {
        if (props.vendorInfo) {
            const formData = props.vendorInfo;
            if (typeof formData.fnsNum === "string") {
                const format = formData.fnsNum.split(",").map((item, i) => ({ id: i, name: item }));
                formData.fnsNum = format;
            }
            if (typeof formData.communicationEmail === "string") {
                const format = formData.communicationEmail.split(",").map((item, i) => ({ id: i, name: item }));
                formData.communicationEmail = format;
            }
            setTimeout(() => {
                if (formData?.primaryMobile) {
                    setMobile(maskMobile(formData?.primaryMobile));
                }
                reset(formData);
            }, 1000);
            formData.lastUpdtUid = props.vendorInfo.lastUpdtUidNam;
            formData.publicMobile = maskMobile(props.vendorInfo.publicMobile);
            formData.adminLastUpdtTs = props.vendorInfo.adminLastUpdtTs ? convertUTCDateToLocalDate(props.vendorInfo.adminLastUpdtTs) : ""
            formData.createTs = props.vendorInfo.createTs ? convertUTCDateToLocalDate(props.vendorInfo.createTs) : ""
            formData.lastUpdtTs = props.vendorInfo.lastUpdtTs ? convertUTCDateToLocalDate(props.vendorInfo.lastUpdtTs) : ""
            setMobile(maskMobile(props.vendorInfo.primaryMobile));
            setFormValue(formData);
        }
    }, [props.vendorInfo]);

    useEffect(() => {
          if (props.user.registrationResponse && props.user.registrationResponse.status === "success") {                        
            props.clearRegistrationStatus();
            popUpAlert({
              title: "Successfully",
              text: "Basic Registration completed successfully!",
              icon: "success",
              timer: 1500,
              showCancelButton: false,
              showConfirmButton: false,
            });
          } else if (props.user.registrationResponse && props.user.registrationResponse.status === "error") {
            props.clearRegistrationStatus();
            popUpAlert({
              title: "Failed!",
              text: props.user.registrationResponse.message,
              icon: "error",
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Ok!",
              closeOnConfirm: false,
            });
          }
        }, [props.user.registrationResponse]);

    const { fields, remove } = useFieldArray({
        control,
        name: "fnsNum"
    });
    let watchFieldArray = watch("fnsNum");
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray?.[index],
        };
    });
    const [addMore, setAddMore] = useState(1);

    const handleRemove = (i) => {
        setAddMore(addMore - 1)
        remove(i);
    }

    const [communicateEmail, setCommunicateEmail] = useState(1);
    const EmailAddFields = () => {
        setCommunicateEmail(communicateEmail + 1)
        EmailAppend({ name: "" });
    };

    const EmailRemoveFields = (i) => {
        setCommunicateEmail(communicateEmail - 1)
        EmailRemove(i);
    }
    // RE
    const { fields: emailField, append: EmailAppend, remove: EmailRemove } = useFieldArray({
        control,
        name: "communicationEmail"
    });

    let watchEmailArray = watch("communicationEmail");
    const controlledEmailFields = emailField.map((emailField, index) => {
        return {
            ...emailField,
            ...watchEmailArray?.[index],
        };
    });

    const updateVendorCallback = () => {
        const payload ={
            vendorId: props.vendorId,
            vendorType: "CSAVDR"
        };        
        props.getVendorInfoList(payload);
        if(props.add_CSA){
            // navigate("/dtahip/vendors/csa?vendor_id="+props.vendorId);
            window.location.href=("/dtahip/vendors/csa?vendor_id="+props.vendorId);
            // navigate("?vendor_id="+props.vendorId);
            // location.reload();
        }
      }

    const onFormSubmit = (data) => {
        if (data.fnsNum && data.fnsNum.length > 0) {
            data.fnsNum = data.fnsNum.map(item => item.name).toString();
        }
        if (data.communicationEmail && data.communicationEmail.length > 0) {
            const commEmails = [...new Set(data.communicationEmail.map(item => item.name))];
            data.communicationEmail = commEmails.toString();
        }
        const timeStamp = new Date().getTime();
        const systemInfo = sessionStorage.getItem("systemInfo");
        const systemData = JSON.parse(systemInfo);
        let role = "";
        if (userData?.Role === "ADMIN") {
            role = "ADM_";
        } else if(userData?.Role === "HIPCRD") {
            role = "CRD_";
        } else {
            role = "VDR_";
        }
        let updatedInfo = {
            firstName: data.firstName,
            lastName: data.lastName,
            fnsNum:  data.fnsNum ? data.fnsNum: "",
            communicationEmail:data.communicationEmail ? data.communicationEmail: "",
            csaFnsNum: data.fnsNum ? data.fnsNum: "",
            csaCommunicationEmail:data.communicationEmail ? data.communicationEmail: "",
            vendorName: data.vendorName,
            primaryEmail: data.primaryEmail,
            primaryMobile: data.primaryMobile,
            publicEmail: data.publicEmail ? data.publicEmail : "",
            publicMobile: data.publicMobile ? data.publicMobile : "", 
            publicWebsite: data.publicWebsite ? data.publicWebsite : "",
            csaText: data.csaText ? data.csaText : "",
            publicPhoto: data.publicPhoto ? data.publicPhoto : "",
            csaPickupSite: data.csaPickupSite ? data.csaPickupSite : "N",
            farmStand: data.farmStand ? data.farmStand : "N",
            farmersMarket: data.farmersMarket ? data.farmersMarket : "N",
            farmersMarketManagers: data.farmersMarketManagers ? data.farmersMarketManagers : "N",
            mobileMarket: data.mobileMarket ? data.mobileMarket : "N",
            forceLogin: data.forceLogin,
            vendorId: props.vendorId,
            id:props.vendorId,
            csaSnapFlag: data.csaSnapFlag,
            additionalContactInfo: data.additionalContactInfo ? data.additionalContactInfo : "",
            products: data.products ? data.products : "",
            businessDesc: data.businessDesc ? data.businessDesc : "",
            lastUpdateTime: data.lastUpdateTime ? data.lastUpdateTime :"",
            createTimeStamp: timeStamp,
            lastUpdtTimeStamp: timeStamp,
            userId: props.userId,
            // submitForm: "Admin",
            submitForm: "Vendor Information",
            vendorType: "CSAVDR",
            lastUpdtUidNam:role+userData?.id,
            // lastUpdtUidNam: userData?.Name,
            ipAddress:systemData.ip,
            loginId: userData?.id
        }

        if (props.add_CSA) {
            setLoading(true);
            setFormValue(updatedInfo);
            const data = {...updatedInfo, isHipAndCsaVdr : true, isVerified: "N",isActive: "N",forceLogin: "N"}; 
            data.primaryMobile =  data.primaryMobile.replace(/\D/g, '');
            data.publicMobile =  data.publicMobile.replace(/\D/g, '');
            props.addUser(data,updateVendorCallback);
            setUpdate(false);
            setMode("view");
        } else {
            if (update) {
                setLoading(true);
                props.updateUser(updatedInfo,updateVendorCallback);
                setFormValue(updatedInfo);
                setUpdate(false);
                setMode("view");
            }
        }       
    };

    useEffect(() =>{
        setLoading(false)
    },[props.user]);

    useEffect(() => {
        setLoading(false);
    },[props?.vendorDetails?.vendorInfoList])
    
    return (

        <div className="tab-content-wrapper">
            { loading &&
                <CommonLoading />
            }
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                    <Col md={6} xs={12} sm={6} xl={6} lg={6}>
                        <h3 className="resText" > CSA VENDOR Details</h3>
                    </Col>
                    {mode === "view" ? <Col className="txt-right">
                        <Button
                            onClick={() => setMode("edit")}
                            className="btn btn-primary">
                            <span ><i className="fa fa-pencil"></i> Edit</span>
                        </Button>
                    </Col> :
                        <Col md={6} xs={12} sm={6} xl={6} lg={6} className="txt-right" >
                            <Button type="submit" onClick={() => setUpdate(true)} className="btn btn-primary m-r-5">
                                <span ><i className="fa fa-check"></i> Update</span>
                            </Button>
                            {!props.add_CSA && <Button
                                onClick={() => {
                                    setMode("view")
                                    if (props?.vendorInfo?.primaryMobile) {
                                        setMobile(maskMobile(props?.vendorInfo?.primaryMobile));
                                    }
                                    reset(props.vendorInfo);
                                }}
                                className="btn btn-primary">
                                <span ><i className="fa fa-times"></i> Cancel</span>
                            </Button>}
                        </Col>
                    }
                </Row>
                <br />
                <Row>
                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="vendorName"
                               aria-label="Farm / Vendor Name required"
                            >
                               Farm / Vendor Name <span className="sr-only">required</span><span aria-hidden="true">*</span>
                               </label>
                            <input
                                {...register("vendorName", {
                                    required: "Farm/Vendor Name is required",
                                })}
                                // value={vendorDetails?.farmName}
                                className={`form-control form-control-lg required dh-input-box ${errors.vendorName ? "dh-error-box" : ""
                                    }`}
                                placeholder=""
                                aria-label="farm/vendor name"
                                disabled={mode === "view"}
                                maxLength={100}
                            /> 
                             {errors.vendorName && (
                            <span className="dh-txt-danger" role="alert" aria-live="assertive">
                            {errors.vendorName.message}
                            </span>)}
                        </div>
                    </Col>
                    <Col md={9} sm={9} xl={9} lg={9}>
                        <div className="row" id="fnsNumbersList">
                            {controlledFields.map((item, i) => {
                                return (
                                    <Fragment key={`fnsNum.${i}`}>
                                        <div
                                            className="col-md-3"
                                            id={`fnsNum.${i}`}
                                        >
                                            <div className="form-group mb-0">
                                                <label
                                                    className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                                    htmlFor={`fnsNum.${i}`}
                                                >
                                                    FNS# for CSA <span className="sr-only">required</span><span aria-hidden="true">*</span>
                                                    {i > 0 && mode === "edit" ? (
                                                        <span  role="button" key={i} className={"text-decoration-underline cursor-pointer dh-remove ml-2 green"}
                                                            onClick={() => {
                                                                handleRemove(i);
                                                            }}
                                                        >
                                                           <i className="fa fa-trash-o"></i>{" "}
                                                            Remove <span className="sr-only">button</span>
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )} 
                                                </label>

                                                <input
                                                    {...register(`fnsNum.${i}.name`, {
                                                        required: true,
                                                        minLength:'7'
                                                        // valueAsNumber: true
                                                    })}
                                                    maxLength={7}
                                                    // onKeyDown={isNumber}
                                                    // control={control}
                                                    onKeyPress={(e) => {
                                                        if (!/^\d$/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
                                                          e.preventDefault();
                                                        }
                                                      }}
                                                    type="text"
                                                    aria-label="fns number"
                                                    className={`form-control form-control-lg fns-number-input dh-input-box required ${errors.fnsNum?.[i]?.name ? "dh-error-box" : ""
                                                        }`}
                                                    disabled={mode === "view" || userData?.Role === "CSAVDR" || userData?.Role === "SUBVDR"}
                                                />
                                                {errors.fnsNum?.[i]?.name && (
                                                    <span className="dh-txt-danger"  role="alert" aria-live="assertive">
                                                        FNS Number is required
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </Fragment>
                                );
                            })}
                        </div>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={12} sm={12} xl={12} lg={12}>
                        <div className="row" id="communicationEmail">
                            {controlledEmailFields.map((item, i) => {
                                return (
                                    <Fragment key={`communicationEmail.${i}`}>
                                        <div
                                            className="col-md-3"
                                            id={`communicationEmail.${i}`}
                                        >
                                            <div className="form-group mb-0">
                                                <label
                                                    className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                                    htmlFor={`communicationEmail.${i}`}
                                                >
                                                    Communication Email <span className="sr-only">required</span><span aria-hidden="true">*</span>
                                                    {i > 0 && mode === "edit" ? (
                                                       <span  role="button"key={i} className={"text-decoration-underline cursor-pointer dh-remove ml-2 green"}
                                                            onClick={() => {
                                                                EmailRemoveFields(i);
                                                            }}
                                                        >
                                                           <i className="fa fa-trash-o"></i>{" "}
                                                            Remove<span className="sr-only">button</span> 
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                    </label>
                                                <input
                                                    {...register(`communicationEmail.${i}.name`, { 
                                                        required:"Communication Email is required",
                                                        pattern: {
                                                            value:
                                                                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                            message: "Invalid Email Address",
                                                        },
                                                    })}
                                                    id="infoEmailID"
                                                    aria-label="infoEmailID"
                                                    aria-labelledby="infoEmailID"
                                                    aria-describedby="infoEmailID"
                                                    onKeyDown={isAlphanumeric}
                                                    type="text"
                                                    maxLength={100}
                                                    className={`form-control form-control-lg communication-email-input dh-input-box required  ${errors.communicationEmail?.[i]?.name ? "dh-error-box" : ""
                                                }`}
                                                disabled={mode === "view"}
                                                />
                                                {errors.communicationEmail?.[i]?.name && (
                                                    <span className="dh-txt-danger"  role="alert" aria-live="assertive">
                                                    {errors.communicationEmail[i].name.message}
                                                    {/* Communication Email is required */}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </Fragment>
                                );
                            })}
                        </div>
                        {mode === 'edit' && controlledEmailFields.length < 10 && (
                            <div
                                className="form-text text-muted dh-short-title"
                                id="communicationEmailID"
                            >
                                <span>Do you have an additional Communication Email? </span>
                                <span role="button"className={"text-decoration-underline cursor-pointer green"} onClick={() => EmailAddFields()}>
                                  <i className="fa fa-plus"></i> Add More <span className="sr-only">button</span> 
                                </span>
                            </div>
                        )}
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="firstName"
                            >
                                First Name <span className="sr-only">required</span><span aria-hidden="true">*</span>
                                </label>
                            <input
                                {...register("firstName", {
                                    required: "First Name is required",
                                })}
                                className={`form-control form-control-lg required dh-input-box ${errors.firstName ? "dh-error-box" : ""
                                    }`}
                                placeholder=""
                                disabled={!props.add_CSA}
                                aria-label="first name"
                                maxLength={20}
                            /> 
                             {errors.firstName && (
                            <span className="dh-txt-danger"  role="alert" aria-live="assertive">
                            {errors.firstName.message}
                            </span>)}
                        </div>
                    </Col>
                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="lastName"
                            >
                                Last Name <span className="sr-only">required</span><span aria-hidden="true">*</span>
                                </label>
                            <input
                                {...register("lastName", {
                                    required: "Last Name is required",
                                })}
                                className={`form-control form-control-lg required dh-input-box ${errors.lastName ? "dh-error-box" : ""
                                    }`}
                                placeholder=""
                                disabled={!props.add_CSA}
                                maxLength={20}
                                aria-label="last name"
                            />
                            {errors.lastName && (
                            <span className="dh-txt-danger"  role="alert" aria-live="assertive">
                            {errors.lastName.message}
                            </span>)}
                        </div>
                    </Col>

                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="primaryPhoneNumber"
                            >
                                Primary Contact Phone <span className="sr-only">required</span><span aria-hidden="true">*</span>
                                </label>
                            <input
                                {...register("primaryMobile", {
                                    required:
                                        "Primary Phone Number is required",
                                    pattern: {
                                        value:
                                            /^\s*[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})\s*$/,
                                        message: "Invalid Phone Number",
                                    },
                                })}
                                type="tel"
                                className={`form-control form-control-lg required dh-input-box ${(errors.primaryMobile) ? "dh-error-box" : ""
                            }`}
                                maxLength={"14"}
                                value={mobile}
                                onChange={(e) =>{
                                    setMobile(maskMobile(e.target.value));
                                }}
                                defaultValue={mobile ? mobile : maskMobile(formValue?.primaryMobile)}
 
                                placeholder="(___) ___-____"
                                id="primaryPhoneNumber"
                                aria-label="primaryPhoneNumber"
                                aria-labelledby="primaryPhoneNumber"
                                aria-describedby="primaryPhoneNumber"
                                required=""
                                disabled={mode === "view"}
                            /> 
                            {(errors.primaryMobile) && (
                                <span className="dh-txt-danger"  role="alert" aria-live="assertive">
                                    {/* {errors.primaryMobile.message} */}
                                    {errors.primaryMobile ? errors.primaryMobile.message : "Primary Phone Number is required"}
                                </span>
                            )}
                        </div>
                    </Col>
                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="infoEmailID"
                            >
                                Primary Contact Email<span className="sr-only">required</span><span aria-hidden="true">*</span>
                                </label>
                            <input
                                {...register("primaryEmail", { required:"Primary Email address is required",
                                    pattern: {
                                        value:
                                            /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "Invalid Email Address",
                                    },
                                })}
                                type="text"
                                className={`form-control form-control-lg required dh-input-box ${errors.primaryEmail ? "dh-error-box" : ""
                                    }`}
                                maxLength="100"
                                id="infoEmailID"
                                aria-label="infoEmailID"
                                aria-labelledby="infoEmailID"
                                aria-describedby="infoEmailID"
                                disabled={!props.add_CSA}
                            /> 
                            {errors.primaryEmail && (
                                <span className="dh-txt-danger"  role="alert" aria-live="assertive">
                                    {errors.primaryEmail.message}
                                </span>
                            )}
                        </div>
                    </Col>
                </Row>
                <br />
                {!props.add_CSA && <Row>
                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="createdBy"
                            >
                                Registered By
                                </label>
                            <input
                                {...register("createdBy")}
                                className={`form-control form-control-lg required dh-input-box ${errors.createdBy ? "dh-error-box" : ""
                                    }`}
                                placeholder=""
                                aria-label="Registered by"
                                disabled={true}
                                value={formValue?.createdBy}
                            />  

                        </div>
                    </Col>
                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="createTs"
                            >
                                Registered Time
                                </label>
                            <input
                                {...register("createTs")}
                                className={`form-control form-control-lg required dh-input-box ${errors.createTs ? "dh-error-box" : ""
                                    }`}
                                placeholder=""
                                aria-label="Registered time"
                                disabled={true}
                                value={formValue?.createTs}
                            /> 

                        </div>
                    </Col>

                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="lastUpdtTs"
                            >
                                Last Updated Time   
                                </label>
                            <input
                                {...register("lastUpdtTs")}
                                className={`form-control form-control-lg required dh-input-box ${errors.lastUpdtTs ? "dh-error-box" : ""
                                    }`}
                                    aria-label="last updated time"
                                disabled={true}
                            />
                            {errors.lastUpdtTs && (
                                <span className="dh-txt-danger">
                                    {errors.lastUpdtTs.message}
                                </span>
                            )}
                        </div>
                    </Col>
                    <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="lastUpdtUidNam"
                            >
                                Last Updated By
                                </label>
                            <input
                                {...register("lastUpdtUidNam")}
                                className={`form-control form-control-lg required dh-input-box ${errors.lastUpdtUidNam ? "dh-error-box" : ""
                                    }`}
                                placeholder=""
                                disabled={true}
                                aria-label="last updated by"
                                value={formValue?.lastUpdtUidNam}
                            /> 
                        </div>
                    </Col>
                </Row>}
                <br />
                <Row>
                     { (userData?.Role === "ADMIN") && <Col md={9} sm={9} xl={9} lg={9}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="additionalContactInfo"
                            >
                                Admin Notes
                            </label>
                            <textarea
                                {...register("additionalContactInfo", {
                                    maxLength: {
                                        value: 3000,
                                        message: "Maximum character count exceeded.",
                                      },
                                })}
                                className={`form-control form-control-lg  ${errors.primary_contact_info
                                    ? "dh-error-box"
                                    : ""
                                    }`}
                                id="additionalContactInfo"
                                rows="3"
                                aria-label="additionalContactInfo"
                                aria-labelledby="additionalContactInfo"
                                aria-describedby="additionalContactInfo"
                                aria-hidden="true"
                                disabled={mode === "view"}
                                defaultValue={formValue?.additionalContactInfo}
                            ></textarea>
                            <span className="float-right text-muted mt-1 ">
                                <i
                                    className="fa fa-info-circle mr-1"
                                    aria-hidden="true"
                                ></i>
                                Max character : 3000
                            </span>
                            {errors.additionalContactInfo && (
                            <span className="dh-txt-danger"  role="alert" aria-live="assertive">
                                {errors.additionalContactInfo.message}
                            </span>)}
                        </div>
                    </Col>}
                    {!props.add_CSA && <Col md={3} sm={3} xl={3} lg={3}>
                        <div className="form-group mb-0">
                            <label
                                className="font-14 mb-2 dh-title-lb smallTitle text-brand"
                                htmlFor="adminLastUpdtTs"
                            >
                                Admin Last Updated
                                </label>
                            <input
                                {...register("adminLastUpdtTs")}
                                className={`form-control form-control-lg required dh-input-box ${errors.adminLastUpdtTs ? "dh-error-box" : ""
                                    }`}
                                    aria-label="admin last updated"
                                disabled={true}
                            /> 
                        </div>
                    </Col>}
                </Row>
            </Form>
        </div>
    );

};
CsaVendorDetailsTab.propTypes = {
    updateVendorDetails: PropTypes.func.isRequired,
    vendorInfo: PropTypes.string,
    updateUser: PropTypes.func.isRequired,
    addUser: PropTypes.func,
    userId: PropTypes.number,
    userAuth: PropTypes.object.isRequired,
    vendorDetails: PropTypes.object.isRequired,
    getVendorInfoList: PropTypes.func,
    add_CSA: PropTypes.bool,
    vendorId:PropTypes.string,
    user : PropTypes.func,
    clearRegistrationStatus: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateVendorDetails: (user) => {
            dispatch({ type: UPDATE_VENDOR, value: user });
        },
        updateUser: (user,callback) => {
            dispatch({ type: PUT_USER, value: user, callback:callback });
        },
        addUser: (user,callback) => {
            dispatch({ type: SET_USER, value: user, callback:callback });
        },
        getVendorInfoList: (payload) => dispatch(getVendorInfoList(payload)),
        clearRegistrationStatus: () => { dispatch(clearRegistrationStatus("")) },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CsaVendorDetailsTab);
